import React from "react";
import {
  changeLanguage,
  LANGUAGE,
  LANGUAGE_EN,
  LANGUAGE_FR
} from "../../utils/i18n/i18n";
import "./LanguageSelector.scss";

interface LanguageOption {
  code: string;
  flag: string;
  name: string;
}

const languages: LanguageOption[] = [
  { code: LANGUAGE_FR, flag: "🇫🇷", name: "Français" },
  { code: LANGUAGE_EN, flag: "🇬🇧", name: "English" }
];

export const LanguageSelector: React.FC = () => {
  const currentLanguage = LANGUAGE;

  const handleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedLanguage = event.target.value;
    if (selectedLanguage !== currentLanguage) {
      changeLanguage(selectedLanguage);
    }
  };

  return (
    <div className="language-selector">
      <select
        className="language-selector__dropdown"
        value={currentLanguage}
        onChange={handleLanguageChange}
        title="Select language"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag}
          </option>
        ))}
      </select>
    </div>
  );
};
